const formatAlteredIconsText = (text: string = '') => (
  <span
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: text
        .replaceAll(/ {2}/g, '<br>')
        .replaceAll(
          /\[\[(.*?)\]\]/g,
          (match) => `<span class="underline font-bold">${match.replace(/[[[\]\]]+/g, '')}</span>`,
        )
        .replaceAll(/\[(.*?)\]/g, (match) => `<span class="font-bold">${match.replace(/[[\]]+/g, '')}</span>`)
        .replaceAll(/\((.*?)\)/g, (_, p1) => `<span class="italic">(${p1})</span>`)
        .replaceAll(/#(.*?)#/g, (match) => `<span class="text-primary-600">${match.replace(/#+/g, '')}</span>`)
        .replaceAll(/{(.*?)}/g, (match) => {
          const formattedMatch = match.replace(/[{}]+/g, '').toLowerCase();

          return `<i class="fa-kit fa-altered-${formattedMatch}" aria-hidden="true" title="${formattedMatch}"></i>`;
        }),
    }}
  />
);

export default formatAlteredIconsText;
